import Button from "../Button";
import CartFooter from "./CartFooter";
import CartHeader from "./CartHeader";
import CartProduct from "./CartProduct";

import { serverPath } from "../../helpers/variables";

import { createContext, useEffect, useState } from "react";

export const AppContext = createContext(null);

const Cart = () => {
  const data = async () => {
    const result = await fetch(serverPath + "products");
    const data = result.json();
  };

  const [cart, setCart] = useState(null);
  const [total, setTotal] = useState(null);
  const [fetchData, setFetchData] = useState(true);

  useEffect(() => {
    fetch(serverPath + "products")
      .then((result) => result.json())
      .then((data) => setCart(data));
  }, [fetchData]);

  useEffect(() => {
    if (cart) {
      setTotal({
        price: cart.reduce((prev, curr) => prev + curr.priceTotal, 0),
        count: cart.reduce((prev, curr) => prev + curr.count, 0),
      });
    }
  }, [cart]);

  const deleteProduct = (id) => {
    setCart((cart) => {
      return cart.filter((el) => el.id !== id);
    });
    fetch(serverPath + "products/" + id, {
      method: "DELETE",
    }).then((res) => {
      if (res.ok) {
        setFetchData((value) => !value);
      }
    });
  };

  const increaseValue = (id) => {
    const product = cart.find((product) => product.id === id);

    const data = {
      ...product,
      count: product.count + 1,
      priceTotal: (product.count + 1) * product.price,
    };

    fetch(serverPath + "products/" + id, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }).then((res) => {
      if (res.ok) {
        setFetchData((value) => !value);
      }
    });
  };

  const decreaseValue = (id) => {
    const product = cart.find((product) => product.id === id);

    const data = {
      ...product,
      count: --product.count <= 0 ? 0 : product.count,
      priceTotal:
        product.count * product.price <= 0 ? 0 : product.count * product.price,
    };

    fetch(serverPath + "products/" + id, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }).then((res) => {
      if (res.ok) {
        setFetchData((value) => !value);
      }
    });
  };

  const changeValue = (id, value) => {
    const product = cart.find((product) => product.id === id);

    const data = {
      ...product,
      count: value,
      priceTotal: value * product.price,
    };

    fetch(serverPath + "products/" + id, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }).then((res) => {
      if (res.ok) {
        setFetchData((value) => !value);
      }
    });
  };

  const addProduct = () => {
    const titles = ["Apple MacBook Air 13", "Apple watch", "Mac Pro"];
    const imges = [
      "./img/products/macbook.jpg",
      "./img/products/apple-watch.jpg",
      "./img/products/mac-pro.jpg",
    ];
    const prices = [100000, 29000, 190000];

    const randomValue = (array) => {
      return array[Math.floor(Math.random() * array.length)];
    };

    const price = randomValue(prices);

    const data = {
      img: randomValue(imges),
      title: randomValue(titles),
      count: 1,
      price: price,
      priceTotal: price,
    };

    fetch(serverPath + "products/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }).then((res) => {
      if (res.ok) {
        setFetchData((value) => !value);
      }
    });
  };

  const products = () => {
    return cart.map((product) => {
      return <CartProduct product={product} key={product.id} />;
    });
  };

  return (
    <AppContext.Provider
      value={{
        deleteProduct,
        increaseValue,
        decreaseValue,
        changeValue,
        addProduct,
      }}
    >
      <section className="cart">
        <CartHeader />
        {cart && products()}
        {total && <CartFooter total={total} />}
        <Button title="Add product!" />
      </section>
    </AppContext.Provider>
  );
};

export default Cart;
